import { render, staticRenderFns } from "./CustodianHistory.vue?vue&type=template&id=14d64b59"
import script from "./CustodianHistory.vue?vue&type=script&lang=js"
export * from "./CustodianHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports